<template>
  <div>
    <div>
      <appointment-steps :stepsData="steps" :activeStep="activeStep" :currentLabel="currentLabel">
        <template slot="content">
          <div v-if="activeStep === 0">
            <queryNotice @next="next" />
          </div>
          <div v-if="activeStep === 1">
            <fillInformation @next="next" @qszmcbh="qszmcdbh" />
          </div>
          <div v-if="activeStep === 2">
            <queryRusult @next="next" @qszmcdbh="qszmcdbh" :resultNumber="resultNumber" />
          </div>
        </template>
      </appointment-steps>
    </div>
    <!--  后台配置权限该功能是否在建  -->
    <!-- <no-data v-else :data="dataNo"></no-data> -->
  </div>
</template>

<script>
import queryNotice from './components/query-notice';
import fillInformation from './components/fill-information';
import hasConstruction from '@iebdc/mixin/hasConstruction';
import queryRusult from './components/query-result.vue';
export default {
  mixins: [hasConstruction],
  components: {
    queryNotice,
    fillInformation,
    queryRusult
  },
  data() {
    return {
      dataNo: {
        src: require('@/pages/iebdc/assets/images/nodata@2x.png'),
        imgWidth: '242px',
        imgHeight: '194px',
        title: '敬请期待',
        description: '正在建设中...'
      },
      activeStep: 0,
      steps: [
        {
          title: '查询须知'
        },
        {
          title: '填写信息'
        },
        {
          title: '查询结果'
        }
      ],
      currentLabel: '权属证明',
      resultNumber: {}
    };
  },
  methods: {
    next(activeStep) {
      this.activeStep = activeStep;
    },
    qszmcdbh(num) {
      this.resultNumber = num;
    }
  }
};
</script>

<style lang="scss" scoped>
/*.wrap {*/
/*  padding: 20px 50px;*/
/*}*/
.appointment-warp {
  .wrap-left {
    width: 135px;
    height: auto;
    float: left;
  }
  .wrap-right {
    height: auto;
    margin-left: 135px;
  }
}
</style>
